<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :sm="12" :md="8" :xl="4">
                    <el-input size="small" v-model="params.trackPath" placeholder="请输入跟踪参数"></el-input>
                </el-col>
                <el-col :sm="12" :md="8" :xl="4">
                    <el-select v-model="params.terminal" placeholder="请选择" size="small">
                        <el-option label="不限制终端" value=""></el-option>
                        <el-option v-for="(item, index) in terminalList" :key="index" :label="`仅看${item.name}的`"
                            :value="item.code"></el-option>
                    </el-select>
                </el-col>
                <el-col :sm="12" :md="8" :xl="4">
                    <el-date-picker size="small" v-model="datetimerange" type="daterange" range-separator="-"
                        value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" :clearable="false"
                        style="width:100%" unlink-panels :picker-options="pickerOptions">
                    </el-date-picker>
                </el-col>
                <el-col :sm="12" :md="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>

        <el-alert title="目前仅支持最多360天的数据" show-icon type="warning"></el-alert>

        <div class="MT20">
            <el-radio-group v-model="type" @change="drawFunnel">
                <el-radio-button :label="1">次数</el-radio-button>
                <el-radio-button :label="2">人数</el-radio-button>
            </el-radio-group>
        </div>

        <div class="MT20" id="container"></div>

        <div class="page-list-box">
            <el-table v-if="type == 1" :data="data && data.pvDetail" border style="width: 100%" v-loading="listLoading"
                size="small" stripe>
                <el-table-column label="步骤编号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="num" label="完成次数">
                </el-table-column>
                <el-table-column prop="preConversionRate" label="上一步转化率">
                    <template slot-scope="scope">
                        <template v-if="scope.row.preConversionRate">
                            {{ scope.row.num }} / {{ data.pvDetail[scope.$index-1].num }} = 
                            {{ scope.row.preConversionRate }}
                        </template>
                    </template>
                </el-table-column>
                <el-table-column prop="globalConversionRate" label="总体转化率">
                    <template slot-scope="scope">
                        <template v-if="scope.row.globalConversionRate">
                            {{ scope.row.num }} / {{ data.pvDetail[0].num }} = 
                            {{ scope.row.globalConversionRate }}
                        </template>
                    </template>
                </el-table-column>
            </el-table>
            <el-table v-if="type == 2" :data="data && data.uvDetail" border style="width: 100%" v-loading="listLoading"
                size="small" stripe>
                <el-table-column label="步骤编号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="num" label="完成人数">
                </el-table-column>
                <el-table-column prop="preConversionRate" label="上一步转化率">
                    <template slot-scope="scope">
                        <template v-if="scope.row.preConversionRate">
                            {{ scope.row.num }} / {{ data.uvDetail[scope.$index-1].num }} = 
                            {{ scope.row.preConversionRate }}
                        </template>
                    </template>
                </el-table-column>
                <el-table-column prop="globalConversionRate" label="总体转化率">
                    <template slot-scope="scope">
                        <template v-if="scope.row.globalConversionRate">
                            {{ scope.row.num }} / {{ data.uvDetail[0].num }} = 
                            {{ scope.row.globalConversionRate }}
                        </template>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import { fetchTerminal } from '@/assets/js/commonApi';
import { Funnel } from '@antv/g2plot';
let startTime, endTime;
const defaultParams = {
    startTime: "",
    endTime: "",
    trackPath: "",
    terminal: "",
}
export default {
    props: {
        id: {
            type: [String, Number],
            default: '',
        },
    },
    data() {
        endTime = this.$utils.formatDate((new Date().getTime()), 'yyyy-MM-dd') + ' 23:59:59';
        startTime = this.$utils.formatDate((new Date().getTime() - 3600 * 1000 * 24 * 7), 'yyyy-MM-dd') + ' 00:00:00';
        return {
            data: null,
            params: {
                ...defaultParams,
                id: this.id
            },
            datetimerange: [this.$route.query.startTime || startTime, this.$route.query.endTime || endTime],
            pickerMinDate1: "",//第一次选中的时间
            pickerOptions: {
                onPick: obj => {
                    this.pickerMinDate1 = new Date(obj.minDate).getTime();
                },
                disabledDate: (time) => {
                    if (this.pickerMinDate1 && time.getTime() <= new Date(endTime).getTime()) {
                        const day1 = 360 * 24 * 3600 * 1000;
                        let maxTime = this.pickerMinDate1 + day1;
                        let minTime = this.pickerMinDate1 - day1;
                        return time.getTime() >= maxTime || time.getTime() <= minTime;
                    } else {
                        return time.getTime() > new Date(endTime).getTime();
                    }
                }
            },
            listLoading: true,
            terminalList: [],
            type: 1,
            funnelPlot: null
        }
    },
    created() {
        this.getTerminal();
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取终端
        getTerminal() {
            fetchTerminal()
                .then((res) => {
                    const { state, result } = res.data;
                    if (state == 1 && result) {
                        this.terminalList = result || [];
                    } else {
                        // this.$message.error(msg || "请求失败");
                    }
                })
        },
        //获取列表
        getDataList() {
            this.params = {
                ...this.params,
                startTime: this.datetimerange && this.datetimerange[0] || '',
                endTime: this.datetimerange && this.datetimerange[1] || '',
            }
            this.listLoading = true;
            this.$request({
                url: "/event/conversionRate/statistics",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.drawFunnel();
                    } else {
                        this.data = null;
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //搜索
        search() {
            // this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [startTime, endTime];
            this.params = {
                ...defaultParams,
                // pageSize: this.params.pageSize,
                id: this.id
            };
            this.getDataList();
        },
        drawFunnel() {
            this.$nextTick(() => {
                this.funnelPlot && this.funnelPlot.destroy();
                this.funnelPlot = new Funnel('container', {
                    data: this.type == 1 ? this.data.pvFunnelData : this.data.uvFunnelData,
                    xField: 'key',
                    yField: 'value',
                    legend: false,
                    shape: 'pyramid',
                    label: {
                        formatter: (datum) => {
                            return `${datum.key}:${datum.value}%`;
                        },
                    },
                    conversionTag: false,
                    tooltip: {
                        follow: true,
                        enterable: true,
                        customContent: (value, items) => {
                            if (!items || items.length <= 0) return;
                            const { data: itemData } = items[0];
                            return (`<div class="PD10">
                                <div>名称：${itemData.key}</div>
                                <div class="MT10">总体转化率：${itemData.value}%</div>
                            </div>`);
                        }
                    }
                });

                this.funnelPlot.render();
            })

        }
    }
}
</script>
<style lang="scss" scoped>
#container {
    width: 100%;
    height: 300px;
}
</style>